import React from "react";

import { formatRuntime } from "@/components/common/utils";

export default function Runtime({
  runtime,
  className,
}: {
  runtime: number;
  className: string;
}) {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className="w-4 h-4 mr-1"
        width={16}
        height={16}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <span className="sr-only">Duration: </span>
      <span>{formatRuntime(runtime)}</span>
    </div>
  );
}
